import { adminOrderMemoModal } from "@/atoms/order/admin-order-memo-modal";
import { toastState } from "@/atoms/system/toast-state";
import { ButtonColor } from "@/common/enum/button-color";
import { H4 } from "@/components/typography/H4";
import { cartItemService } from "@/services/cart-item-service";
import { Button, Modal, TextInput } from "flowbite-react";
import { useEffect, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";

interface MemoItem {
  name: string;
  value: string;
}

function EditMemoModal() {
  const [item, setItem] = useRecoilState(adminOrderMemoModal);
  const setToast = useSetRecoilState(toastState);
  const [memoInputs, setMemoInputs] = useState<MemoItem[]>([]);
  const [originalMemoInputs, setOriginalMemoInputs] = useState<MemoItem[]>([]);

  useEffect(() => {
    if (item?.memoItems) {
      setMemoInputs(item.memoItems);
      setOriginalMemoInputs(item.memoItems);
    }
  }, [item]);

  const isChanged = () => {
    return memoInputs.some(
      (memo, index) => memo.value !== originalMemoInputs[index]?.value
    );
  };

  const handleTextInputChange = (index: number, value: string) => {
    setMemoInputs((prev) =>
      prev.map((memo, i) => (i === index ? { ...memo, value } : memo))
    );
  };

  const handleSave = async () => {
    try {
      if (!item?.id) return;

      await cartItemService.update(item.id, { ...item, memoItems: memoInputs });
      setToast({
        show: true,
        messages: ["상품 옵션을 수정했습니다."],
      });
      setItem(null);
    } catch (error) {
      console.error("Failed to update memo:", error);
    }
  };

  return (
    <Modal show={item !== null} onClose={() => setItem(null)}>
      <Modal.Header>
        <H4>상품 메모 수정하기</H4>
      </Modal.Header>
      <Modal.Body>
        <div className="space-y-4">
          {memoInputs.map((memo, index) => (
            <div key={index} className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                {memo.name}
              </label>
              <TextInput
                className="w-full"
                value={memo.value}
                onChange={(e) => handleTextInputChange(index, e.target.value)}
              />
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex justify-start w-full">
          <Button
            color={isChanged() ? ButtonColor.PRIMARY : ""}
            onClick={handleSave}
            disabled={!isChanged()}
          >
            수정하기
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default EditMemoModal;
